export default __webpack_public_path__ + "static/media/proposal.638b7400.jpeg";